import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';

export class ControladorDeInicio
{
    public get Usuario() { return UsuarioActual; }



    public readonly Vista = new Vista();
}

type Opcion = {
    Icono?: string,
    Titulo?: string,
    Subtitulo?: string,
    Modo?: string,
    Resaltado?: boolean,
    Accion?: Function,
    Tipo: 'opcion' | 'titulo',
};


type Modo =
    string |
    'vacio' |
    'ingresos'

    ;

type SubModo =
    'vacio' |
    'configuracion-usuario' |
    'notificaciones';
'chat'
    ;

type Estado = 'iniciado' | 'cargando' | 'error' | 'mod';
type Buscador =
    'vacio' |
    'ninguno';

class Vista
{
    public readonly Titulo: string = 'Caja';

    public Opciones: Opcion[] = [

        { Tipo: 'titulo', Titulo: 'Mostrador' },
        { Tipo: 'opcion', Icono: 'cart-outline', Modo: 'ingresos', Titulo: 'Ingresos' },
        { Tipo: 'opcion', Icono: 'cart-outline', Modo: 'movimientos-ajustes', Titulo: 'Movimientos de Ajuste' },
        { Tipo: 'opcion', Icono: 'cart-outline', Modo: 'movimientos', Titulo: 'Movimientos' },

        { Tipo: 'titulo', Titulo: 'Pagos' },
        { Tipo: 'opcion', Icono: 'cart-outline', Modo: 'mercadopago', Titulo: 'MercadoPago' },
        { Tipo: 'opcion', Icono: 'cart-outline', Modo: 'decidir', Titulo: 'Decidir SAC' },

    ];

    protected modo: Modo = 'ingresos';
    get Modo(): Modo { return this.modo; }
    set Modo( m: Modo ) { this.modo = m; this._onModo.dispatch(); this._onEditarQuery.dispatch( this.query + '&m=' + this.modo ); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected query: string = '';
    public set Query( x: string )
    {
        this.query = x;
        this._onEditarQuery.dispatch( x );
    }
    private _onEditarQuery = new SimpleEventDispatcher<string>();
    public get onEditarQuery() { return this._onEditarQuery.asEvent(); }

    protected submodo: SubModo = 'vacio';
    get SubModo(): SubModo { return this.submodo; }
    set SubModo( m: SubModo ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected menuAbierto: boolean = true;
    get MenuAbierto(): boolean { return this.menuAbierto; }
    set MenuAbierto( m: boolean ) { this.menuAbierto = m; this._onMenuAbierto.dispatch(); }
    private _onMenuAbierto = new SignalDispatcher();
    public get onMenuAbierto() { return this._onMenuAbierto.asEvent(); }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    protected buscador: Buscador = 'ninguno';
    get Buscador(): Buscador { return this.buscador; }
    set Buscador( m: Buscador ) { this.buscador = m; this._onBuscador.dispatch(); }
    private _onBuscador = new SignalDispatcher();
    public get onBuscador() { return this._onBuscador.asEvent(); }



}

export const Controlador = new ControladorDeInicio();


